// Force firefox to reload page when hitting back button.
// Allows document ready event to fire.
const onunload = function() {}; // eslint-disable-line no-empty-function
export default onunload;
